// Copyright (c) 2017 Deere & Company

import FormValidation from '../state/form-validation';
import actions from '../../actions-list';
import {getDefaultState} from '../state';

const updateFormValidity = (state, action) =>
    FormValidation.update(state, {
        [action.property]: {
            $set: action.validity
        }
    });

const resetFormValidation = () => getDefaultState().formValidation;

export default (state = getDefaultState().formValidation, action) => {

    const actionTypes = {
        [actions.RESET_PRODUCT_REGISTRATION_FORM_VALIDATION]: resetFormValidation,
        [actions.UPDATE_PRODUCT_REGISTRATION_FORM_VALIDATION]: updateFormValidity
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/product/product-registration/reducers/form-validation.js